import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-703587a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-adds" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill-out" }, "Please fill in your delivery information", -1))
const _hoisted_3 = { class: "sequence" }
const _hoisted_4 = {
  key: 0,
  class: "type-address"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "switchr" }
const _hoisted_7 = { style: {"margin":"16px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_switch = _resolveComponent("van-switch")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "Add Address",
      skipPath: $setup.skipPath,
      backgroundColor: "#424040",
      fontColor: "#fff"
    }, null, 8, ["skipPath"]),
    _hoisted_2,
    _createVNode(_component_van_form, {
      "validate-first": "",
      onFailed: $setup.onFailed,
      onSubmit: $setup.onSubmit,
      ref: "refForm",
      clearable: "",
      autofocus: ""
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_van_field, {
          modelValue: $setup.state.phone,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.phone) = $event)),
          modelModifiers: { trim: true },
          placeholder: "e.g. 700200100",
          type: "tel",
          name: "phone",
          class: "phone_field",
          clearable: "",
          rules: $setup.rules.phone
        }, {
          label: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_DropDown, { onOnDropDown: $setup.onDropDown }, null, 8, ["onOnDropDown"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "rules"])), [
          [_directive_focus]
        ]),
        _createVNode(_component_van_field, {
          modelValue: $setup.state.firstName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.firstName) = $event)),
          modelModifiers: { trim: true },
          type: "text",
          name: "firstName",
          placeholder: "First name",
          clearable: "",
          rules: [{ required: true, message: 'Please input your firstname' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: $setup.state.LastName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.LastName) = $event)),
          modelModifiers: { trim: true },
          name: "LastName",
          placeholder: "Last name",
          clearable: "",
          rules: [{ required: true, message: 'Please input your lastname' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: $setup.state.County,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.County) = $event)),
          name: "County",
          placeholder: "County",
          "right-icon": "arrow",
          clearable: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.newlyIncreased('County'))),
          rules: [{ required: true, message: 'Please select a region' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: $setup.state.Town,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.Town) = $event)),
          name: "Town",
          "right-icon": "arrow",
          placeholder: "Town",
          clearable: "",
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.newlyIncreased('Town'))),
          rules: [{ required: true, message: 'Please select a region' }]
        }, null, 8, ["modelValue"]),
        ($setup.stations_list && $setup.stations_list.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ($setup.state.isFiltrate !='1')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.pickupDeliver(true))),
                    class: _normalizeClass({ 'addredt-active': $setup.state.type_active === true})
                  }, "Pickup Station", 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.state.area_door_id == 1 ? $setup.pickupDeliver(false) : null)),
                class: _normalizeClass({ 'addredt-active': $setup.state.area_door_id === 1 && $setup.state.type_active === false, 'addredt_active_dispad': $setup.state.area_door_id != 1 })
              }, "Deliver to Doorstep", 2)
            ]))
          : _createCommentVNode("", true),
        ($setup.state.Town)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              ($setup.state.type_active)
                ? (_openBlock(), _createBlock(_component_van_field, {
                    key: 0,
                    modelValue: $setup.state.pickup,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.pickup) = $event)),
                    name: "pickup",
                    clearable: "",
                    placeholder: "Choose Pickup Station",
                    "right-icon": "arrow",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.newlyIncreased('pickup'))),
                    rules: [{ required: true, message: 'Please select a Choose Pickup Station' }]
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              ($setup.state.area_door_id === 1 && $setup.state.type_active === false)
                ? (_openBlock(), _createBlock(_component_van_field, {
                    key: 1,
                    modelValue: $setup.state.pickupout,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.state.pickupout) = $event)),
                    name: "pickupout",
                    label: "Address:",
                    type: "textarea",
                    rows: "2",
                    maxlength: "200",
                    "show-word-limit": "",
                    clearable: "",
                    placeholder: "Please fill in the detailed address",
                    rules: [{ required: true, message: 'Please enter the address in detail' }]
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_field, {
            name: "switch",
            label: "Set to default address",
            clearable: ""
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_switch, {
                modelValue: $setup.state.checked,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.state.checked) = $event)),
                size: "20"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            color: "#f76900",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onFailed", "onSubmit"])
  ]))
}